import { useState } from 'react';
import { EntryQuickAction } from '../../../../../types/custom-worksheet-v2';
import { useDispatch } from 'react-redux';

import { Description } from '../Configurations';
import EditInput from '../../components/EditInput';
import { editQuickAction } from '../../../store/slice';

type DefaultDescriptionProps = {
    id: string;
    quickAction: EntryQuickAction;
    isSummary: boolean;
};

function DefaultDescription({ id, quickAction, isSummary }: DefaultDescriptionProps): JSX.Element {
    const dispatch = useDispatch();

    const [description, setDescription] = useState<string | undefined | null>(quickAction.payload.defaultDescription);

    function handleUpdateDescription(): void {
        if (typeof description !== 'string') {
            return;
        }

        const newDescription = description.trim();

        if (!newDescription && !quickAction.payload.defaultDescription) {
            setDescription(null);
            return;
        }

        // If default description value hasn't change, don't update
        if (newDescription === quickAction.payload.defaultDescription) {
            return;
        }

        dispatch(
            editQuickAction({ id, type: quickAction.type, payload: { ...quickAction.payload, defaultDescription: newDescription || null } })
        );
    }

    return (
        <div className="flex flex-col gap-1">
            <Description
                title="Default Description"
                description="Provide a description for the reconciliation entry. Leave this blank to use the field name."
                isOptional
            />
            <EditInput
                autoFocus={false}
                showActionButtons={false}
                placeholder="Enter a description..."
                value={description || undefined}
                onChange={setDescription}
                onSave={handleUpdateDescription}
                onCancel={(): void => setDescription(quickAction.payload.defaultDescription)}
            />
        </div>
    );
}

export default DefaultDescription;
